import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class UrlParamsRoute extends Route {
  @service messageSettings;

  crumb() {
    return {
      name: 'URL Parameters',
      path: 'actions.url_params',
    };
  }

  setupController() {
    this.messageSettings.loadURLParamsCredential.perform();
  }
}
